import { useState } from "react";
import { BlockStack, Button, InlineStack, TextField } from "@shopify/polaris";
import { ClipboardIcon, ChatIcon } from "@shopify/polaris-icons";

// Links sent to providers/trasladistas always point at production, even when
// generated from localhost or a preview build — they're opened on a phone.
export const PUBLIC_APP_URL = "https://admin.gomoverent.com";

// Public phone pages on this same app, by 6-character link code:
// /s/ = provider service capture, /g/ = trasladista expense tickets.
// (/captura/:token and /gastos/:token still serve links sent before codes.)
export const captureUrl = (code) => `${PUBLIC_APP_URL}/s/${code}`;
export const gastosUrl = (code) => `${PUBLIC_APP_URL}/g/${code}`;

// "Avanza SGL725C 2026": the model's first word (full names like "Avanza XLE
// CVT" are noise in a chat message), plate and year.
export function unitLabel({ modelName, plate, year } = {}) {
  return [String(modelName || "").trim().split(/\s+/)[0], plate, year].filter(Boolean).join(" ");
}

// Default message for a service capture link. WhatsApp renders *text* as bold.
export const serviceCaptureMessage = (unit, url) =>
  `Hola 👋\n\nPor favor ingresa antes de realizar el servicio programado a la unidad *${unit}* para enviar evidencias 📸\n\n👉 ${url}\n\n¡Gracias!`;

// Copies either the bare link or a ready-to-paste WhatsApp message.
// `url`/`message`/`label` let other public pages (e.g. trasladista expense
// tickets) share their own link.
function FieldLinkShare({ code, unit, url: urlProp, message: messageProp, label }) {
  const [copied, setCopied] = useState(null); // "link" | "message"
  const url = urlProp || captureUrl(code);
  const message = messageProp || serviceCaptureMessage(unit || "", url);

  const copy = async (what) => {
    try {
      await navigator.clipboard.writeText(what === "link" ? url : message);
      setCopied(what);
      setTimeout(() => setCopied(null), 2000);
    } catch {
      /* clipboard blocked; the field is selectable */
    }
  };

  return (
    <BlockStack gap="200">
      <TextField
        label={label || "Liga para el proveedor"}
        value={url}
        readOnly
        autoComplete="off"
        selectTextOnFocus
      />
      <InlineStack gap="200">
        <Button icon={ChatIcon} variant="primary" onClick={() => copy("message")}>
          {copied === "message" ? "¡Mensaje copiado!" : "Copiar para WhatsApp"}
        </Button>
        <Button icon={ClipboardIcon} onClick={() => copy("link")}>
          {copied === "link" ? "¡Copiada!" : "Copiar liga"}
        </Button>
      </InlineStack>
    </BlockStack>
  );
}

export default FieldLinkShare;
